export default "__VITE_ASSET__bmQMC4mI__"